import { render, staticRenderFns } from "./iconChevronBas.vue?vue&type=template&id=79323004"
import script from "./iconChevronBas.vue?vue&type=script&lang=js"
export * from "./iconChevronBas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports